var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrowseElectricUsedVehicles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.4 3H0L3 0H10.5V7.5L7.5 10.5V4.3C5.7 5.5 4.5 7.6 4.5 10C4.5 13.5 7.1 16.4 10.5 16.9V17V19.9C5.5 19.4 1.5 15.2 1.5 10C1.5 7.3 2.6 4.8 4.4 3ZM21.5 10C21.5 12.7 20.4 15.2 18.6 17H23L20 20H12.5V12.5L15.5 9.5V15.7C17.3 14.5 18.5 12.4 18.5 10C18.5 6.5 15.9 3.60001 12.5 3.10001V3V0.100006C17.5 0.600006 21.5 4.8 21.5 10Z",
    fill: "#49B275"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowseElectricUsedVehicles);
export default __webpack_public_path__ + "static/media/browse-electric-used-vehicles.915a6df470853c03f2c71a79db4a65ac.svg";
export { ForwardRef as ReactComponent };